import ArrowIcon from "components/button/ArrowIcon";
import React from "react";
import "./Table.css"; // Renamed CSS file for clarity

const UserTable = ({ className, data, columns }) => {
  return (
    <div className="user-table-relative">
      <div className={`user-table-container ${className}`}>
        <table
          className={`user-table ${className || ""}`}
          onMouseEnter={(e) => e.currentTarget.classList.add("hovered")}
          onMouseLeave={(e) => e.currentTarget.classList.remove("hovered")}
        >
          {" "}
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr
                key={item.id}
                className="user-table-row clickable-row"
              >
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={column.key === "email" ? "email-column" : ""}
                  >
                    {column.render
                      ? column.render(item[column.key], item)
                      : item[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {data.length > 3 ? (
          <div className="scroll-arrow">
            <ArrowIcon
              width={20}
              height={20}
              fill="#59b2a5"
              direction="bottom"
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default UserTable;
